import React, { SVGAttributes } from 'react';
import styles from './Icon.module.scss';
import * as icons from '@heroicons/react/outline';
import cn from 'classnames';

export type IconName = keyof typeof icons;

interface IconBaseProps {
  name: IconName;
  size?: 16 | 20 | 24 | 32 | 48 | 64 | 96;
}

type AttributesToOmit = 'height' | 'width' | 'style';
type IconProps = IconBaseProps & Omit<SVGAttributes<HTMLOrSVGElement>, AttributesToOmit>;

export const Icon: React.VFC<IconProps> = ({ name, size = 24, className, ...restProps }) => {
  const IconTag = icons[name];

  return <IconTag className={cn(styles['o-icon'], className)} height={size} width={size} {...restProps} />;
};
